import React, { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import ReactQuill from 'react-quill';
import Uploader from '../../../partial/Uploader';
import PulseLoader from 'react-spinners/PulseLoader';

function Answer({answer, RemoveAnswer, UpdateAnswer, readOnly}) {
    const {_id} = answer

    const [answerBody, setAnswerBody] = useState(answer?.answerBody||'')
    const [img, setImg] = useState(answer?.img||'')
    const [isCorrectAnswer, setIsCorrectAnswer] = useState(answer?.isCorrectAnswer||false)
    useEffect(()=>{
        UpdateAnswer({_id, img, answerBody, isCorrectAnswer})
    },[img, answerBody, isCorrectAnswer ])
    const onDeleteAnswerClicked = ()=>{
        RemoveAnswer(_id)
    }
    if(!answer || !answer._id)   return <PulseLoader color={"#FFF"} />

    const content = (
        <>
                <div className="form__title-row">
                    {/* <h2>New Answer</h2> */}
                    <div className="form__action-buttons">
                    <button type='button'
                className="icon-button"
                disabled={readOnly}
                readOnly={readOnly}
                title="Delete"
                onClick={(onDeleteAnswerClicked)}
            >
                <FontAwesomeIcon icon={faTrashCan} />
            </button>
                    </div>
                </div>            
                <label className="form__label" htmlFor={`${_id}title`}>
                    Title:</label>
                    {readOnly && <ReactQuill
                     theme='bubble'
                    readOnly
                    value={answerBody}
                    
                    ></ReactQuill>}
                  {!readOnly &&   <ReactQuill                  
                    value={answerBody}
                    onChange={setAnswerBody}
                    modules={{
                        toolbar: [
                          [{ 'header': '1'}, {'header': '2'}, {'font': []}],
                          [{ 'align': [] }],
                          [{ 'direction': 'rtl' }],   
                          //[{ align: '' }, { align: 'center' }, { align: 'right' }, { align: 'justify' }],
                          [{size: []}],
                          ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                          [{'list': 'ordered'}, {'list': 'bullet'}/*,       {'indent': '-1'}, {'indent': '+1'}*/],
                          ['link'],
                          ['clean']
                        ],
                        clipboard: {
                          matchVisual: false,
                        }
                      }}
                    />  }  

{!readOnly &&     <Uploader label={'Img'} folderId={'MANAGE_QUESTION'} file={img} setFile={setImg} isImg={true} />}

                 <label className="form__label form__checkbox-container" htmlFor={`${_id}currect`}>
                    Correct Answer:
                    <input
                      disabled={readOnly}
                      readOnly={readOnly}
                        className="form__checkbox"
                        id={`${_id}currect`}
                        name="isCorrectAnswer"
                        type="checkbox"
                        checked={isCorrectAnswer}
                        onChange={(e)=>setIsCorrectAnswer(prev => !prev)}
                    />
                </label>

         

           
        </>
    )
  return content
}

export default Answer